module.exports = __webpack_public_path__ + "static/media/10.8f2691f4.jpg";